import { ArrowLeft } from 'phosphor-react';
import { Button, Text } from '@typedream/ui';
import { useEventPlateId } from '@udecode/plate-core';
import { Serializer } from '@typedream/components';
import { CollectionCMSElement } from '@typedream/core';
import { useTPlateEditorRef } from '../../plate';
import { CMSTemplates } from './constants';

export function SelectTemplate({ goNext, goBack }: { goNext: () => void; goBack: () => void }) {
  const editorID = useEventPlateId();
  const editor = useTPlateEditorRef(editorID as string);

  return (
    <div className="flex flex-col gap-2 w-full">
      <div className="flex flex-row gap-4 w-full mb-4 items-center">
        <Button variant="outline" size="xs" onClick={goBack} className="w-fit p-2.5">
          <ArrowLeft size={16} />
        </Button>
        <Text variant="main" size="lg" weight="medium">
          Select a Template
        </Text>
      </div>

      <div className="flex w-full gap-2">
        <div className="flex flex-col gap-2 grow">
          <div className="bg-neutral-100 dark:bg-neutral-800 rounded-lg px-4 py-2 w-full">Blog</div>
        </div>
        <div className="flex flex-col gap-2 pb-48">
          {Object.values(CMSTemplates).map((template) => {
            const columns = template.settings?.numCol > 1 ? template.settings?.numCol : 2;
            const collection: Partial<CollectionCMSElement> = {
              type: 'collection_cms',
              id: 'preview',
              width: 900,
              collection_template: template,
              children: Array.from(Array(columns).keys()).map(() => template.template) as any[],
            };

            return (
              <div
                key={template.templateKey}
                className="bg-neutral-50 dark:bg-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-lg p-4 w-fit cursor-pointer"
                role="none"
                onClick={() => {
                  editor.emitter.emit('popup:on-cms-set-template', template);
                  goNext();
                }}
              >
                <div
                  className="bg-neutral-25 dark:bg-neutral-900 rounded-lg p-4 shadow-sm flex items-center justify-center"
                  style={{ width: 500, height: 250 }}
                >
                  <div style={{ transform: 'scale(0.6)', width: 1200 }}>
                    <Serializer
                      rootStyle={{ height: '100%', minHeight: 'unset' }}
                      node={collection as CollectionCMSElement}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
